"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _reactRouterRedux = require("react-router-redux");
var _createGenericReducer = _interopRequireDefault(require("./createGenericReducer"));
var reducers = {
  config: (0, _createGenericReducer["default"])(),
  device: (0, _createGenericReducer["default"])({
    host: '',
    platform: ''
  }),
  routing: _reactRouterRedux.routerReducer
};
module.exports = reducers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/thunderball-client/lib/reducers/index.js
// module id = 3164
// module chunks = 25